import { render, staticRenderFns } from "./DetectInput.vue?vue&type=template&id=4e1f7cfc"
import script from "./DetectInput.vue?vue&type=script&lang=js"
export * from "./DetectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports